// Node Modules
var moment = require('moment');

/*
@function calculateAgeScore
@param {Object} listing
@param {String} filterValue
*/
function calculateAgeScore(listing, filterValue) {
    var weight = 1;
    var value = 0;
    var threshold = 0;

    if(!listing.year) {
        return {
            weight: weight,
            value: value,
            score: value * weight,
            metThreshold: (value * weight) > threshold
        };
    }

    var age = moment().diff(listing.year + '-01-01', 'years');

    if(filterValue === '< 10') {
        if(age < 10) {
            value = 10;
        } else if(age <= 50) {
            value = 0;
        } else {
            value = -10;
        }
    } else if(filterValue === '10-50') {
        if(10 <= age && age <= 50) {
            value = 10;
        } else {
            value = 0;
        }
    } else if(filterValue === '50+') {
        if(age > 50) {
            value = 10;
        } else if(age >= 10) {
            value = 0;
        } else {
            value = -10;
        }
    }

    return {
        weight: weight,
        value: value,
        score: value * weight,
        metThreshold: (value * weight) >= threshold,
        metWhyWhyNotThreshold: (value * weight) >= 10
    };
}

module.exports = calculateAgeScore;
